import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { useTheme } from "next-themes";

/**
 * Bascule clair / sombre du header, en un clic.
 * L'icône montre le thème vers lequel on bascule : lune en mode clair, soleil en mode sombre.
 */
export function HeaderSettingsMenu() {
  const { setTheme, resolvedTheme } = useTheme();
  const reduceMotion = useReducedMotion();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = mounted && resolvedTheme === "dark";
  const label = isDark ? "Passer en mode clair" : "Passer en mode sombre";
  const hidden = reduceMotion ? { opacity: 0 } : { opacity: 0, transform: "rotate(-90deg) scale(0.6)" };
  const shown = reduceMotion ? { opacity: 1 } : { opacity: 1, transform: "rotate(0deg) scale(1)" };

  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      aria-label={label}
      title={label}
      className="rhythm-icon-btn active:scale-[0.96]"
    >
      <span className="relative grid h-5 w-5 place-items-center" aria-hidden="true">
        <AnimatePresence initial={false} mode="popLayout">
          <motion.span
            key={isDark ? "sun" : "moon"}
            className="absolute inset-0 grid place-items-center"
            initial={hidden}
            animate={shown}
            exit={hidden}
            transition={{ duration: 0.2, ease: [0.23, 1, 0.32, 1] }}
          >
            {isDark ? <Sun size={18} /> : <Moon size={18} />}
          </motion.span>
        </AnimatePresence>
      </span>
    </button>
  );
}
